import React from 'react';
import UlaznaFakturaForma from './UlaznaFakturaForma';

/* Dinarska i devizna ulazna faktura dele istu formu — razlikuje ih samo kvačica
   "Devizna" i kurs koji se uz nju popunjava. Dva odvojena fajla bi značila dva
   mesta koja se moraju održavati istovremeno. `idFakture` otvara postojeću. */
const NovaDinarska = ({ sefZaUnos, naUnesenu, idFakture, naKoKz }) =>
    <UlaznaFakturaForma devizna={false} sefZaUnos={sefZaUnos} naUnesenu={naUnesenu} idFakture={idFakture} naKoKz={naKoKz} />;

export default NovaDinarska;
